import styled, { css } from 'styled-components';

const dragActive = css`
  border-color: #78e5d5;
`;

const dragReject = css`
  border-color: #e57878;
`;

const messageColors = {
  default: '#999',
  error: '#e57878',
  success: '#78e5d5',
};

export const DropContainer = styled.div.attrs({
  //className: 'dropzone',
})`
  width: 10rem;
  height: 2.15rem;
  cursor: pointer;
  transition: height 0.2s ease;
  ${(props) => props.isDragActive && dragActive};
  ${(props) => props.isDragReject && dragReject};

  align-self: center;
`;

export const UploadMessage = styled.p`
  display: flex;
  color: ${(props) => messageColors[props.type || 'default']};
  justify-content: center;
  align-items: center;
  padding: 15px 0;
`;
export const ImprovButton = styled.div`
  padding: 0.4rem 1rem;
  background-color: #eff1f5;
  color: #585e66;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;

  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-bottom: 1rem;

  svg {
    margin-right: 0.5rem;
    height: 1rem;
    width: 1rem;
  }

  path {
    stroke: #585e66;
  }
`;
